<template>
  <div id="app">
    <!-- MAIN WRAP CONTENT -->
    <section class="container">
      <div class="overflow-hidden white" style="font-size: 1.8rem;">
        <p class="pv4 tc">
          <span class="dn dib-ns ph3">Staromeštianska pivotéka</span>

          <strong class="dib ph3">
            <a :href="'tel:' + mobileNumber.replace(/ /g, '')">{{ mobileNumber }}</a>
          </strong>

          <span class="dib ph3"  v-if="openingHours[today.getDay()]">
            <span v-if="openingHours[today.getDay()].closed===true">{{this.isEnglish ? 'Closed today' : 'Dnes zatvorené'}}</span>
            <span v-else>{{this.isEnglish ? 'Open today' : 'Dnes otvorené'}}</span>
            <strong class="nowrap" v-if="openingHours[today.getDay()].closed!==true">
              {{ openingHours[today.getDay()].openFrom }}
              -
              {{ openingHours[today.getDay()].openTo }}
            </strong>
          </span>

          <span v-if="nameToday && nameToday[0] !== '_'" class="dib ph3">
            {{this.isEnglish ? 'Name day today' : 'Meniny má'}}
            <strong>{{ nameToday }}</strong><span
              v-if="nameTomorrow && nameTomorrow[0] !== '_'"
            >, {{this.isEnglish ? 'tomorrow' : 'zajtra'}} {{ nameTomorrow }}
            </span>
            <span class="pointer pl3" @click="updateLanguage">{{this.isEnglish ? '🇬🇧 anglický jazyk' : '🇸🇰 slovenský jazyk'}}</span>
          </span>
        </p>
      </div>

      <div class="row">
        <div class="col-md-4 bg-white">
          <div class="ph4 ph5-l pt5 pb4">
            <div>
              <a href="/">
                <img
                  class="img-responsive center"
                  src="images/logo-header.png"
                  alt="Staromeštianska pivotéka"
                >
              </a>
            </div>

            <div
              class="dn-l pt6 overflow-hidden"
              v-if="!isWysiwygEmpty(this.weeklyBeer) || isWysiwygEmpty(this.weeklyFood)"
            >
              <div class="pb5" v-if="!isWysiwygEmpty(this.weeklyBeer)">
                <img :src="isEnglish ? 'images/weekly-beer.en.png' : 'images/weekly-beer.png'" class="img-responsive" alt="Pivo týždňa">
                <div v-html="weeklyBeer" class="weekly-beer pt4"></div>
              </div>

              <div class="pb5" v-if="!isWysiwygEmpty(this.weeklyFood)">
                <img :src="isEnglish ? 'images/weekly-food.en.png' : 'images/weekly-food.png'" class="img-responsive" alt="Špecialita týždňa">
                <div v-html="weeklyFood" class="weekly-food pt4"></div>
              </div>
            </div>

            <div class="mt4">
              <smp-beers-on-tap :beers="beersOnTap" :isEnglish="this.isEnglish" :months="this.months" />
            </div>

            <div class="mt5 dn db-l">
              <h3 class="ttu">{{ isEnglish  ? 'Current' : 'Aktuálne' }}</h3>
              <div
                class="fb-page"
                data-href="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
                data-tabs="timeline"
                data-width="500"
                data-height="700"
                data-small-header="true"
                data-adapt-container-width="true"
                data-hide-cover="false"
                data-show-facepile="false"
              >
                <blockquote
                  cite="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
                  class="fb-xfbml-parse-ignore"
                >
                  <a href="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/">
                    Staromeštianska pivotéka
                  </a>
                </blockquote>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="white pa4 pa5-l">
            <div
              class="dn db-l overflow-hidden"
              v-if="!isWysiwygEmpty(this.weeklyBeer) || isWysiwygEmpty(this.weeklyFood)"
            >
              <div class="row gap-20">
                <div class="col-sm-6" v-if="!isWysiwygEmpty(this.weeklyBeer)">
                  <img :src="isEnglish ? 'images/weekly-beer.en.png' : 'images/weekly-beer.png'" class="img-responsive" alt="Pivo týždňa">
                  <div v-html="preposFixStr(weeklyBeer)" class="weekly-beer pt4"></div>
                </div>

                <div class="col-sm-6" v-if="!isWysiwygEmpty(this.weeklyFood)">
                  <img :src="isEnglish ? 'images/weekly-food.en.png' : 'images/weekly-food.png'" class="img-responsive" alt="Špecialita týždňa">
                  <div v-html="preposFixStr(weeklyFood)" class="weekly-food pt4"></div>
                </div>
              </div>

              <hr style="
                display: block;
                margin: 40px 0;
                height: 17px;
                background: url(images/chalkline.png) no-repeat;"
              >
            </div>

            <smp-menu-offer :isEnglish="this.isEnglish"  />

            <div class="row mt4">
              <div class="col-md-8 mt4 mt0-l">
                <div class="ba bw3 pa3">
                  <div class="b f2 tc">{{ isEnglish ? 'Allergens' : 'Alergény' }}</div>
                  <div class="mb3 tc">[výnos č. 2319/2007-100]</div>
                  <div class="dt f4">
                    <div v-for="(allergen, i) in allergens" class="dt-row">
                      <div class="dtc b">{{ i + 1 }}</div>
                      <div class="dtc pl2">{{ allergen | preposFix }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mt4 mt0-l">
                <div class="ba bw3 pa3 b lh-copy">
                  <p>{{isEnglish ? 'The weight of meat and other materials is given in raw state.' : 'Hmotnosť mäsa a&nbsp;ostatných surovín je uvedená v&nbsp;surovom stave.'}}</p>
                  <p class="mt4">{{isEnglish ? 'Our kitchen accepts orders till 9:15 p.m.' : 'Kuchyňa prijíma poslednú objednávku do&nbsp;21:15.'}}</p>
                  <p class="mt4">{{isEnglish ? 'This menu is arranged by team of our cooks.' : 'Jedálny lístok zostavil tím&nbsp;kuchárov Staromeštianska pivotéka.'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--col-md-8-->
      </div>
      <!--row-->
    </section>
    <!-- /MAIN WRAP CONTENT -->

    <!-- FOOTER -->
    <footer>
      <div class="container white">
        <!-- ROW -->
        <div class="row tc">

          <!-- FOOTER COLUMN 1 -->
          <div class="col-md-4">
            <div class="">
              <h5>{{this.isEnglish ? 'ADDRESS' : 'ADRESA'}}</h5>
              <p>
                Staromeštianska pivotéka <br>
                Kozia 12 <br>
                Bratislava
                <!--% before: Sládkovičova 11 -->
              </p>
            </div>

            <div class="mt5">
              <h5>{{this.isEnglish ? 'RESERVATIONS' : 'REZERVÁCIE'}}</h5>
              <p>
                <a
                  :href="'tel:' + mobileNumber.replace(/ /g, '')"
                  class="nowrap"
                  style="font-size: 1.3em;"
                >{{ mobileNumber }}</a><br>
                <a href="mailto:pivoteka@staromestan.beer">pivoteka@staromestan.beer</a>
              </p>
            </div>
          </div>

          <!-- FOOTER COLUMN 2 -->
          <div class="col-md-4">
            <div class="pa5">
              <img
                class="img-responsive center"
                src="/images/logo-footer.png"
                alt="Staromeštianska pivotéka"
              >
            </div>
          </div>

          <!-- FOOTER COLUMN 3 -->
          <div class="col-md-4">
            <div class="">
              <h5>{{this.isEnglish ? 'OPENING HOURS' : 'OTVÁRACIE HODINY'}}</h5>
              <p>
                <span
                  v-for="index in [1, 2, 3, 4, 5, 6, 0]"
                  :class="{ 'smp-green b': today.getDay() === index }"
                >
                  <span class="ttc">{{ weekDays[index] }}:</span>

                  <span v-if="openingHours[index].closed !== true">
                    {{ openingHours[index].openFrom }} - {{ openingHours[index].openTo }}
                  </span>

                  <span v-else>
                    {{ isEnglish ? 'closed' : 'zatvorené' }}
                  </span>
                  <br>
                </span>
              </p>
            </div>
          </div>

        </div>
        <!-- /ROW -->

        <div class="mt6">
           <smp-map />
        </div>

        <div class="dn-l pt5 tc">
          <h3 class="ttu">{{ isEnglish  ? 'Current' : 'Aktuálne' }}</h3>
          <div
            class="fb-page"
            data-href="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
            data-tabs="timeline"
            data-width="500"
            data-height="700"
            data-small-header="true"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="false"
          >
            <blockquote
              cite="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
              class="fb-xfbml-parse-ignore"
            >
              <a href="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/">
                Staromeštianska pivotéka
              </a>
            </blockquote>
          </div>
        </div>

        <!-- FOOTER COPYRIGHT -->
        <div class="copyright">
          <span class="db dib-ns">
            <ul class="footer-social">
              <li>
                <a
                  class="social-facebook"
                  href="https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
                  target="_blank"
                >
                  <i class="icon-facebook white"></i>
                </a>
              </li>
            </ul>
          </span>

          <span class="db dib-ns pl4 pt2">Staromeštianska pivotéka</span>

          <span class="db dib-ns pl4 pt2">
            <a href="mailto:pivoteka@staromestan.beer">pivoteka@staromestan.beer</a>
          </span>

          <span class="db dib-ns pl4 pt2">
            © Staromeštianska pivotéka - STAROMEŠŤAN s.r.o.  2017
          </span>

        </div>
        <!-- /FOOTER COPYRIGHT -->

        <!-- FOOTER SCROLL UP -->
        <div v-show="windowScrollTop > 400" class="scrollup">
          <a @click.prevent="scrollToTop" href="#">
            <span class="icon-chevron-up"></span>
          </a>
        </div>
        <!-- /FOOTER SCROLL UP -->
      </div>
      <!--container-->

    </footer>
    <!-- /FOOTER -->
  </div>
</template>

<script>
import {englishMonths, englishWeekDays, months, weekDays} from '@/locale/date'
import SmpBeersOnTap from '@/components/BeersOnTap'
import SmpMap from '@/components/Map'
import SmpMenuOffer from '@/components/MenuOffer'
import allergens from '@/data/allergens'
import allergensEn from '@/data/allergens.en'
import nameDays from '@/data/name-days'
import {preposFixStr} from '@/utils/preposfix'
import dayOfYear from 'day-of-year'
import jump from 'jump.js'

export default {
    name: 'app',
    components: {
      SmpBeersOnTap,
      SmpMap,
      SmpMenuOffer,
    },


    data () {
      return {
        isEnglish: false, // Marek K.
        allergens,
        months,
        weekDays,
        nameDays,
        today: new Date(window.today),
        weeklyBeer: __INITIAL_STATE__.weeklyBeer || '',
        weeklyFood: __INITIAL_STATE__.weeklyFood || '',
        beersOnTap: [...__INITIAL_STATE__.beersOnTap || []],
        mobileNumber: '+421 2 396 662 63',
        openingHours: [
          // sunday
          {
            closed: true,
            openFrom: '16:00',
            openTo: '23:00',
          },
          // monday
          {
            closed: true,
            openFrom: '16:00',
            openTo: '23:00',
          },
          // tuesday
          {
            openFrom: '16:00',
            openTo: '23:00',
          },
          // wednesday
          {
            openFrom: '16:00',
            openTo: '23:00',
          },
          // thursday
          {
            openFrom: '16:00',
            openTo: '23:00',
          },
          // friday
          {
            openFrom: '16:00',
            openTo: '23:00',
          },
          // saturday
          {
            openFrom: '16:00',
            openTo: '23:00',
          },

        ],

        windowScrollTop: 0,
      }
    },

    computed: {
      nameToday () {
        return this.nameDays[dayOfYear(window.today) - 1]
      },

      nameTomorrow () {
        return this.nameDays[dayOfYear(window.today)]
      }
    },

    methods: {
      updateLanguage() {
        this.isEnglish = !this.isEnglish
        this.months = this.isEnglish ? englishMonths : months
        this.weekDays = this.isEnglish ? englishWeekDays : weekDays
        this.allergens = this.isEnglish ? allergensEn : allergens;

        location.hash = this.isEnglish ? '#en' : ''
      },

      preposFixStr,

      scrollToTop () {
        jump('html')
      },

      saveScrollPosition () {
        this.windowScrollTop = (window.pageYOffset || document.documentElement.scrollTop)
          - (document.documentElement.clientTop || 0)
      },

      isWysiwygEmpty (str) {
        const div = document.createElement('div')
        div.innerHTML = str
        return div.textContent.length === 0
      },
    },

    mounted () {
      window.addEventListener('scroll', this.saveScrollPosition, { passive: true });

      if (location.hash === '#en') {
        this.isEnglish = true;
        this.months = this.isEnglish ? englishMonths : months
        this.weekDays = this.isEnglish ? englishWeekDays : weekDays
        this.allergens = this.isEnglish ? allergensEn : allergens;
      }
    },

    beforeDestroy () {
      window.removeEventListener('scroll', this.saveScrollPosition)
    },
  }
</script>

<style src="@/assets/css/reset.css" />
<style src="@/assets/css/bootstrap-grid.css" />
<style src="@/assets/css/dina.css" />
<style src="@/assets/css/staromestan.css" />
<style src="@/assets/fonts/b33r-icons/styles.css" />

<style>
  html {
    height: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-family: sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%
  }

  body {
    margin: 0;
    background: black;
    background-image: url(/images/chalkboard.jpg?v=3);
    background-size: cover;
  }

  *,
  *:before,
  *:after {
    -webkit-box-sizing: inherit;
    -moz-box-sizing: inherit;
    box-sizing: inherit;
  }

  [class^="icon-"]:before,
  [class*=" icon-"]:before {
    vertical-align: middle;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block
  }

  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline
  }

  audio:not([controls]) {
    display: none;
    height: 0
  }

  [hidden],
  template {
    display: none
  }

  a {
    background-color: transparent
  }

  a:active,
  a:hover {
    outline: 0
  }

  abbr[title] {
    border-bottom: 1px dotted
  }

  b,
  strong {
    font-weight: 700
  }

  dfn {
    font-style: italic
  }

  mark {
    color: #000;
    background: #ff0
  }

  small {
    font-size: 80%
  }

  sub,
  sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline
  }

  sup {
    top: -.5em
  }

  sub {
    bottom: -.25em
  }

  img {
    border: 0
  }

  svg:not(:root) {
    overflow: hidden
  }

  figure {
    margin: 1em 40px
  }

  hr {
    height: 0;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box
  }

  pre {
    overflow: auto
  }

  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em
  }

  button,
  html input[type=button],
  input[type=reset],
  input[type=submit] {
    -webkit-appearance: button;
    cursor: pointer
  }

  button[disabled],
  html input[disabled] {
    cursor: default
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    padding: 0;
    border: 0
  }

  input {
    line-height: normal
  }

  input[type=checkbox],
  input[type=radio] {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    height: auto
  }

  input[type=search] {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    -webkit-appearance: textfield
  }

  input[type=search]::-webkit-search-cancel-button,
  input[type=search]::-webkit-search-decoration {
    -webkit-appearance: none
  }

  fieldset {
    padding: .35em .625em .75em;
    margin: 0 2px;
    border: 1px solid silver
  }

  legend {
    padding: 0;
    border: 0
  }

  textarea {
    overflow: auto
  }

  optgroup {
    font-weight: 700
  }

  table {
    border-spacing: 0;
    border-collapse: collapse
  }

  td,
  th {
    padding: 0
  }


  html {
    font-size: 10px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
  }

  a:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px
  }

  figure {
    margin: 0
  }

  img {
    vertical-align: middle
  }

  .img-responsive {
    display: block;
    max-width: 100%;
    height: auto
  }

  .color-inherit,
  .color-inherit:hover {
    color: inherit;
  }

  .serif {
    font-family: Lora;
  }

  .sans-serif {
    font-family: Poppins;
  }

  .item-img:before {
    display: none;
  }

  a,
  .smp-green {
    color: #c0d56c;
  }

  .smp-dark-green {
    color: #738f2a;
  }

  .denne-menu + .menu-ponuka {
    margin-top: 30px;
  }

  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both
  }

  .animated.dur-05 {
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
  }

  .animated.dur-025 {
    -webkit-animation-duration: 0.25s;
    animation-duration: 0.25s;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0)
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none
    }
  }

  .fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown
  }

  .green {
    color: #738f2a
  }

  .bg-green {
    background-color: #738f2a;
  }

  .row-no-padding > [class*="col-"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .weekly-beer ul li,
  .weekly-food ul li {
    list-style-type: circle;
    list-style-position: outside;
    margin-left: 1.2em;
  }
  .weekly-beer * { background:none !important;} /* stale pastuju s bg odnekaal */
  .weekly-beer ol li,
  .weekly-food ol li {
    list-style-type: decimal;
    list-style-position: outside;
    margin-left: 1.2em;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue?04a0444a